import { makeStyles } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { FormattedMessage } from "react-intl";

import { InputField } from "../input-field/InputField";

interface ViewDocumentInputProps {
  label: string;
  viewCallback: () => void;
  selectCallback: () => void;
}

const useStyles = makeStyles((theme) => ({
  inputDocumentInfo: {
    fontSize: 17,
    color: theme.palette.primary.light,
  },
}));

export const ViewDocumentInput = (props: ViewDocumentInputProps, ...rest) => {
  const classes = useStyles();
  const { label, viewCallback, selectCallback } = props;

  return (
    <Grid item xs={12} sm={12} lg={12}>
      <InputField
        startAdornment={
          <InputAdornment position="start">
            <IconButton edge="start" onClick={selectCallback}>
              <AttachFileIcon />
            </IconButton>
          </InputAdornment>
        }
        value={label}
        fullWidth
        readOnly
        endAdornment={
          <InputAdornment position="end">
            <IconButton edge="end" onClick={viewCallback}>
              <Typography
                className={classes.inputDocumentInfo}
                variant="h4"
                component="h4"
              >
                <FormattedMessage id="sharedScreen.clickToViewDocument" />
              </Typography>
            </IconButton>
          </InputAdornment>
        }
        {...rest}
      />
    </Grid>
  );
};
